import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import useScreenSize from '../../hooks/useScreenSize';

import { RefundContainer, RefundDescription, RefundOkButton, RefundTitle } from './styles';

interface RefundContentProps {
  closeHandler?: () => void;
}

const RefundContent: FC<RefundContentProps> = ({ closeHandler }) => {
  const { t } = useTranslation();
  const { isMobile } = useScreenSize();
  return (
    <RefundContainer>
      <RefundTitle isMobile={isMobile}>{t('transactions:refund')}</RefundTitle>
      <RefundDescription isMobile={isMobile}>{t('infos:refund')}</RefundDescription>
      {!isMobile && (
        <RefundOkButton onClick={closeHandler}>{t('buttons:continue')}</RefundOkButton>
      )}
    </RefundContainer>
  )
};

export default RefundContent;